import * as XLSX from "xlsx";

export const exportExternalUsersToExcel = (externalUsersData) => {
  try {
    const exportData = [];

    // Header row
    const headerRow = [
      "Name",
      "Email",
      "Role",
      "Access Granted By",
      "Access From",
      "Access Till",
      "Status",
    ];
    exportData.push(headerRow);

    // Data rows
    externalUsersData.forEach((user) => {
      const row = [
        user?.name || "-",
        user?.email || "-",
        user?.role === "-" ? "Not Assigned" : user?.role || "-",
        user?.grantedBy || "-",
        user?.accessFrom || "-",
        user?.accessTill || "-",
        user?.status || "-",
      ];
      exportData.push(row);
    });

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(exportData);

    // Set column widths
    ws["!cols"] = [
      { wch: 25 }, // Name
      { wch: 30 }, // Email
      { wch: 20 }, // Role
      { wch: 30 }, // Access Granted By
      { wch: 15 }, // Access From
      { wch: 15 }, // Access Till
      { wch: 12 }, // Status
    ];

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "External Users");

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split("T")[0];
    const filename = `External_Users_${timestamp}.xlsx`;

    // Download file
    XLSX.writeFile(wb, filename);

    return { success: true };
  } catch (error) {
    console.error("Export failed:", error);
    return { success: false, error };
  }
};
